module.exports = __webpack_public_path__ + "img/partner_58.0bcb57d7.png";